export enum DisplayOption {
  webshop = 0,
  jpf = 1,
  combined = 2,
  hidden = 3,
  webshop_and_cv_database = 4
}

export type SiteAlias = 'nationalevacaturebank' | 'intermediair' | 'itbanen'

export type Feature = 'logo' | 'spotlight' | 'highlight' | 'booster_450' | 'booster_550'

export type SiteAbbreviation = 'nvb' | 'iol' | 'itb'

export type SiteName = 'Nationale Vacaturebank' | 'Intermediair' | 'Tweakers Carrière'

export type Upgrade = {
  name: string,
  features: Array<string>,
  sites: Array<SiteAlias>,
  requiredFeatures: Array<string>,
  requiredSites: Array<SiteAlias>,
}

export type JobPosting = {
  daysOnline: number
  features: string[]
  name: string
  predefined: Record<string, string>
  publishOn: SiteAlias[]
  type: 'jobposting'
  available?: number
}

export type WebshopPackage = {
  productCode?: string
  price?: number
  name?: string
  jobPosting?: JobPosting
  upgrades?: Upgrade[]
  descriptions?: string[]
  listImage?: string
  detailImage?: string
  productInformation?: string
  commercialProductDescription?: string
  profileView?: any
}
